export enum EnvironmentEnum {
  dev = 'Development',
  dev_cloud = 'Development',
  stating = 'Staging',
  prod = 'Production',
}
